export const normalizeURLSlashes = (url: string) =>
  url ? url.replace(/([^:]\/)\/+/g, '$1') : undefined;
